import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

export function PasswordInput({ testid, className = "", ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className={`relative ${className}`}>
      <Input {...props} type={show ? "text" : "password"} data-testid={testid} className="pr-10" />
      <button type="button" tabIndex={-1} onClick={() => setShow((s) => !s)} aria-label="toggle password"
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-th-blue transition-colors">
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
